export default __webpack_public_path__ + "static/swift-239da3f80e9a6dcbe59987dd108a805f.png";